import { isset } from "legacy/helpers.es6"
import FeedbackPage from "legacy/marinascom-review/FeedbackPage"
import ReviewForm from "legacy/marinascom-review/ReviewForm"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery is loaded globally, not via an import

class ReviewController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      starValue: this.props.rating,
      review: this.props.review,
      processing: false,
      submitted: false,
      userEmail: this.props.userEmail,
      marinaName: this.props.marinaName,
      reservationID: this.props.reservationID,
      tripDate: this.props.tripDate,
      userToken: this.props.userToken,
    }
    this.setParentState = this.setParentState.bind(this)
    this.ajaxSubmit = this.ajaxSubmit.bind(this)
  }

  setParentState(state) {
    this.setState(state)
  }

  reviewForm() {
    return (
      <ReviewForm
        setParentState={this.setParentState}
        state={this.state}
        ajaxSubmit={this.ajaxSubmit}
        validator={this.validator}
        marinaName={this.props.marinaName}
        reservationID={this.props.reservationID}
        marinaId={this.props.marinaId}
        userId={this.props.userId}
      />
    )
  }

  ajaxSubmit() {
    const postData = {
      stars: this.state.starValue,
      review: this.state.review,
      user_email: this.state.userEmail,
      user_token: this.state.userToken,
    }
    if (!isset(this.state.email)) {
      postData.username = this.state.username
      postData.password = this.state.password
    }
    $.post(
      "/account/reservations/" + this.state.reservationID + "/review",
      postData,
      (data) => {
        this.setState({ submitted: true })
      }
    ).fail((data) => {
      this.setState({
        processing: false,
        submitError: JSON.parse(data.responseText).error,
      })
    })
  }

  toggleSection() {
    if (this.state.submitted === true) {
      return (
        <FeedbackPage state={this.state} setParentState={this.setParentState} />
      )
    } else {
      return <div>{this.reviewForm()}</div>
    }
  }

  render() {
    return (
      <div id="active-captain-review-controller">{this.toggleSection()}</div>
    )
  }
}

ReviewController.propTypes = {
  rating: PropTypes.number,
  review: PropTypes.string,
  userEmail: PropTypes.string,
  marinaName: PropTypes.string.isRequired,
  reservationID: PropTypes.string.isRequired,
  tripDate: PropTypes.string.isRequired,
  userToken: PropTypes.string.isRequired,
  marinaId: PropTypes.string,
  userId: PropTypes.string,
}

export default ReviewController
